































import { defineComponent, computed, toRefs, PropType } from '@vue/composition-api';
import { DARK_POST_STATUS_MAP as DarkPostStatus } from '@tt4b/ttam-enums';

import QuestionTooltip from '@/components/common/question-tooltip/index.vue';

export default defineComponent({
  name: 'TtamMaterialDarkPost',
  components: {
    QuestionTooltip,
  },
  props: {
    value: {
      type: Number as PropType<DarkPostStatus>,
      default: DarkPostStatus.OFF,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { value } = toRefs(props);

    const _darkPostStatus = computed({
      get() {
        return value.value === DarkPostStatus.ON;
      },
      set(val) {
        emit('input', val ? DarkPostStatus.ON : DarkPostStatus.OFF);
      },
    });

    const isShowDarkPostWarning = computed(() => !_darkPostStatus.value);

    return {
      _darkPostStatus,
      isShowDarkPostWarning,
    };
  },
});
